import styled, { css } from 'styled-components';

export const PhoneStyles = styled.div`
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  display: flex;
  align-items: center;
  margin-top: ${({ mt }) => mt}px;
  max-width: ${({ mw }) => mw}px;
  ${({ isWrap }) => {
    if (isWrap) {
      return css`
        flex-wrap: wrap;
      `;
    }
    return null;
  }}
`;

export const Text = styled.span`
  margin-left: 4px;
  white-space: nowrap;

  &:last-of-type {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
